module.exports = __webpack_public_path__ + "2d43e2e4f5145defcb630dac4bf411bc.png";